/**
 * En edición/lectura, el GET trae precioUnitario neto (lista − descuento de renglón).
 * La UI de FacturaForm calcula sobre precio de lista + porcDesc; hay que normalizar.
 */

const round2 = (n: number) => Math.round(n * 100) / 100;

export type DetallePrecioFactura = {
  precioLista?: number;
  precioUnitario?: number;
  porcDesc?: number;
  descuento?: number;
};

/** Resuelve precio de lista desde campos del detalle (GET factura / pedido). */
export function resolverPrecioListaDetalle(detalle: DetallePrecioFactura): number {
  const listaExplicita = Number(detalle.precioLista ?? 0);
  if (listaExplicita > 0) {
    return round2(listaExplicita);
  }

  const precioUnitNeto = Number(detalle.precioUnitario ?? 0);
  if (precioUnitNeto <= 0) {
    return 0;
  }

  const descuentoMonto = Number(detalle.descuento ?? 0);
  if (descuentoMonto > 0) {
    return round2(precioUnitNeto + descuentoMonto);
  }

  const porcDesc = Number(detalle.porcDesc ?? 0);
  if (porcDesc > 0 && porcDesc < 100) {
    return round2(precioUnitNeto / (1 - porcDesc / 100));
  }

  return round2(precioUnitNeto);
}

export function normalizarDetallesFacturaVentaParaEdicion<T extends DetallePrecioFactura>(
  detalles: T[] | undefined | null,
): T[] {
  return (detalles || []).map((detalle) => {
    const precioLista = resolverPrecioListaDetalle(detalle);
    const porcDesc = Number(detalle.porcDesc ?? 0);
    return {
      ...detalle,
      precioLista,
      precioUnitario: precioLista,
      porcDesc,
    };
  });
}
